<template>

  <nav class="navbar main-header">

    <div class="wrap-header">

      <div class="nav-block">

        <div class="logo-nav" >

          <span class="burguer-menu" data-toggle="offcanvas" role="button">
        
          </span>

          <img class="logo-sendibox" src="/static/img/logo-login.png" alt="">

        </div>

        <div class="nav-icon">

          <div class="nav-nuevo">

            <notifications-menu></notifications-menu>

            <user-menu :user="user"></user-menu>

          </div>

        </div>

      </div>

    </div>

  </nav>

  
</template>

<script>
import { mapState } from 'vuex'
import MessagesMenu from './MessagesMenu'
import TasksMenu from './TasksMenu'
import NotificationsMenu from './NotificationsMenu'
import UserMenu from './UserMenu'
import LogOut from './LogOut'

export default {
  name: 'DashHeader',
  components: {
    MessagesMenu,
    NotificationsMenu,
    TasksMenu,
    UserMenu,
    LogOut
  },
  props: ['user'],
  computed: {
    ...mapState(['userInfo'])
  }
}
</script>



// WEBPACK FOOTER //
// DashHeader.vue?022f5d06